/* RESPONSIBLE TEAM: team-messenger */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type Router from '@ember/routing/router-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class MessengerIndexRoute extends IntercomRoute {
  @service declare router: Router;
  @service declare finStandaloneService: FinStandaloneService;

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-messenger',
    };
  }

  async beforeModel(transition: any) {
    let { tab, section } = transition;

    if (this.finStandaloneService.canAccessPlatformMessengerSettingsTab && !tab) {
      this.router.replaceWith('apps.app.settings.channels.messenger.standalone-platform');
      return;
    }

    this.router.replaceWith('apps.app.settings.channels.messenger.web', {
      queryParams: {
        tab: tab || 'content',
        section: section || '',
      },
    });
  }
}
